import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { USER_CONTRACT_DOMICILIATION } from '@app/modules/user-settings/consts/user-contract-dom/user-contract-dom.const';
import { GpsV2Service, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mnf-modal-contract-domiciliation',
  templateUrl: './modal-contract-domiciliation.component.html',
  styleUrls: ['./modal-contract-domiciliation.component.scss']
})
export class ModalContractDomiciliationComponent {

  // Monto a domiciliar
  amount: number;
  // Datos de la cuenta bancaria a domiciliar
  bankName: string;
  // Clabe de la cuenta bancaria a domiciliar
  clabe: string;
  // Tipo de domiciliación
  viewValue: string
  // Información del usuario
  user: any;
  // Nombre completo del inversionista
  name: string;
  // Meses
  months: number;
  // Tipo de plan
  typePlan: boolean;
  // Frecuencia de cargo
  frecuency: any;
  // ID Banco
  idBank: string;

  // Contrato a mostrar
  contractTemplate: SafeHtml;

  constructor(private domSanitizer: DomSanitizer, private userServ: UserService, private modalServ: ModalService, private gpsServ: GpsV2Service, private toastr: ToastrService, private toastrServ: ToastrService, private matDialog: MatDialogRef<ModalContractDomiciliationComponent>) { }

  ngOnInit() {
    // Juntar nombre
    this.name = this.user?.name + ' ' + this.user?.fatherSurname + ' ' + this.user?.motherSurname;
    
    // Mostrar contrato con la siguiente información: Nombre, Banco, Clabe, Monto y Fecha
     this.contractTemplate = this.domSanitizer.bypassSecurityTrustHtml(
       USER_CONTRACT_DOMICILIATION.replace(/{{name}}/g, this.name || '').
          replace('{{viewValue}}', this.frecuency.viewValue).
          replace('{{bankName}}', this.bankName).
          replace('{{clabe}}', this.clabe).
          replace('{{amountToRecollect}}', this.amount.toString())
    )
  }

  /** Función para continuar */
  next() {
    const m = this.modalServ.openModalVerifyPassword(this.user?.email);

    m.afterClosed().subscribe(r => {
      if (r) {
        const gps = this.gpsServ.getCoordinatesFromLocalStorage();
    
        const executeContractFlow = () => {
          const infoToSend = { 
            bankName: this.bankName, 
            amountToRecollect: this.amount.toString(), 
            clabe: this.clabe,
            typePlan: this.typePlan ? 'Standard' : 'Premium',
            frecuency: this.frecuency?.value,
            totalMonths: this.months,
            idBank: this.idBank
          };
    
          this.userServ.signatureContractDomiciliation(infoToSend).subscribe(r => {
            if (r) {
              // Cerrar modal de contrato
              this.matDialog.close();
    
              this.userServ.createDirectDebit(infoToSend).subscribe({
                next: (r) => {
                  const m = this.modalServ.openModalConfirmDomiciliation(r);
    
                  // Al cerrar el modal reiniciar la página
                  m.afterClosed().subscribe(() => {
                    location.reload();
                  });
                },
                error: err => {
                  if (err.error?.err !== 'TS01') {
                    this.toastrServ.warning(err.error?.msg);
                  }
                }
              });
            } else {
              this.toastr.warning('No se pudo firmar el contrato de domiciliación.');
            }
          });
        };
    
        if (gps) {
          // Coordenadas ya disponibles
          executeContractFlow();
        } else {
          // Obtener coordenadas antes de continuar
          this.gpsServ.defineGPS().subscribe((r) => {
            if (r) {
              executeContractFlow();
            } else {
              this.toastr.warning('No se pudo obtener la ubicación para continuar.');
            }
          });
        }
    
      } else {
        this.toastr.info('Es necesario que ingrese su contraseña para continuar.');
      }
    });
    

  }

}
